var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FEFEFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9341_7533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9712 8.07692C12.9712 6.44662 14.2928 5.125 15.9231 5.125C17.5534 5.125 18.875 6.44662 18.875 8.07692C18.875 9.70723 17.5534 11.0289 15.9231 11.0289C14.2928 11.0289 12.9712 9.70723 12.9712 8.07692ZM7.80325 7.80329C8.65618 6.95036 9.81301 6.47119 11.0192 6.47119C11.1989 6.47119 11.3774 6.48182 11.5541 6.50274C11.8969 6.54332 12.1418 6.8541 12.1013 7.19689C12.0607 7.53967 11.7499 7.78465 11.4071 7.74407C11.279 7.7289 11.1495 7.72119 11.0192 7.72119C10.1445 7.72119 9.30565 8.06867 8.68714 8.68718C8.06863 9.30569 7.72115 10.1446 7.72115 11.0193V14.452C7.72115 14.7462 7.6593 15.034 7.54278 15.2981H14.4957C14.3792 15.034 14.3173 14.7462 14.3173 14.452V12.5776C14.3173 12.2324 14.5971 11.9526 14.9423 11.9526C15.2875 11.9526 15.5673 12.2324 15.5673 12.5776V14.452C15.5673 14.6764 15.6565 14.8916 15.8151 15.0503C15.9738 15.209 16.189 15.2981 16.4135 15.2981C16.7586 15.2981 17.0385 15.5779 17.0385 15.9231C17.0385 16.2683 16.7586 16.5481 16.4135 16.5481H5.625C5.27982 16.5481 5 16.2683 5 15.9231C5 15.5779 5.27982 15.2981 5.625 15.2981C5.84941 15.2981 6.06464 15.209 6.22332 15.0503C6.38201 14.8916 6.47115 14.6764 6.47115 14.452V11.0193C6.47115 9.81304 6.95032 8.65622 7.80325 7.80329ZM9.41357 18.375C9.41357 18.0298 9.6934 17.75 10.0386 17.75H12.0001C12.3453 17.75 12.6251 18.0298 12.6251 18.375C12.6251 18.7202 12.3453 19 12.0001 19H10.0386C9.6934 19 9.41357 18.7202 9.41357 18.375Z",
    fill: "#47712B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9341_7533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/NotifyIcon.ef4c75404d0f8964c48986483e47c8e4.svg";
export { ForwardRef as ReactComponent };